export interface ServiceGalleryImage {
  src: string;
  alt: string;
}

export interface ServiceGalleryDetail {
  slug: string;
  title: string;
  summary: string;
  beforeImages: ServiceGalleryImage[];
  afterImages: ServiceGalleryImage[];
}

export const serviceGalleryDetails: ServiceGalleryDetail[] = [
  {
    slug: "residential-construction",
    title: "Residential Construction",
    summary: "See how we turn raw spaces into finished homes with stronger structure, better planning, and cleaner execution.",
    beforeImages: [
      { src: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1200&q=80", alt: "Residential site before construction work" },
      { src: "https://images.unsplash.com/photo-1489515217757-5fd1be406fef?auto=format&fit=crop&w=1200&q=80", alt: "House interior before renovation work" },
    ],
    afterImages: [
      { src: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1200&q=80", alt: "Completed modern residential house exterior" },
      { src: "https://images.unsplash.com/photo-1600210492493-0946911123ea?auto=format&fit=crop&w=1200&q=80", alt: "Completed finished home interior" },
    ],
  },
  {
    slug: "commercial-construction",
    title: "Commercial Construction",
    summary: "See how commercial spaces move from base condition to finished environments built for business use and customer flow.",
    beforeImages: [
      { src: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1200&q=80", alt: "Commercial interior before fit-out work" },
      { src: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=80", alt: "Office building shell before finishing work" },
    ],
    afterImages: [
      { src: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1200&q=80", alt: "Completed commercial office interior" },
      { src: "https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=1200&q=80", alt: "Completed commercial building project" },
    ],
  },
  {
    slug: "industrial-infrastructure",
    title: "Industrial Infrastructure",
    summary: "Track industrial work from pre-execution setup to finished infrastructure built for reliable operations.",
    beforeImages: [
      { src: "https://images.unsplash.com/photo-1581093588401-22d65b1a4a05?auto=format&fit=crop&w=1200&q=80", alt: "Industrial site before development work" },
      { src: "https://images.unsplash.com/photo-1513828742140-ccaa28f3eda0?auto=format&fit=crop&w=1200&q=80", alt: "Warehouse structure before completion" },
    ],
    afterImages: [
      { src: "https://images.unsplash.com/photo-1621905252507-b35492cc74b4?auto=format&fit=crop&w=1200&q=80", alt: "Completed industrial facility exterior" },
      { src: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=1200&q=80", alt: "Completed industrial warehouse setup" },
    ],
  },
  {
    slug: "renovation-remodeling",
    title: "Renovation And Remodeling",
    summary: "Compare existing spaces with finished upgrades to understand layout, utility, and finish improvements.",
    beforeImages: [
      { src: "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?auto=format&fit=crop&w=1200&q=80", alt: "Old room condition before remodeling" },
      { src: "https://images.unsplash.com/photo-1472224371017-08207f84aaae?auto=format&fit=crop&w=1200&q=80", alt: "Kitchen area before renovation" },
    ],
    afterImages: [
      { src: "https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=1200&q=80", alt: "Remodeled kitchen after renovation" },
      { src: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=1200&q=80", alt: "Renovated modern living room" },
    ],
  },
  {
    slug: "project-management",
    title: "Project Management",
    summary: "See how planning, coordination, and supervision support a smoother path from project start to handover.",
    beforeImages: [
      { src: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1200&q=80", alt: "Project planning meeting before execution" },
      { src: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1200&q=80", alt: "Coordination session before project rollout" },
    ],
    afterImages: [
      { src: "https://images.unsplash.com/photo-1483058712412-4245e9b90334?auto=format&fit=crop&w=1200&q=80", alt: "Project delivery documents after completion" },
      { src: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1200&q=80", alt: "Successful final project handover meeting" },
    ],
  },
  {
    slug: "maintenance-support",
    title: "Maintenance Support",
    summary: "Maintenance work that restores damaged areas and helps properties stay safe, clean, and ready for use.",
    beforeImages: [
      { src: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=1200&q=80", alt: "Facility issue before maintenance support" },
      { src: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?auto=format&fit=crop&w=1200&q=80", alt: "Infrastructure wear before repair work" },
    ],
    afterImages: [
      { src: "https://images.unsplash.com/photo-1562259949-e8e7689d7828?auto=format&fit=crop&w=1200&q=80", alt: "Area restored after maintenance service" },
      { src: "https://images.unsplash.com/photo-1581092921461-eab10380d5df?auto=format&fit=crop&w=1200&q=80", alt: "Maintenance team completing final quality checks" },
    ],
  },
];
